import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Branches from "@/branches/branches";
import { useLocalization } from "@/context/localization-context";

export default function Page() {
  const { t } = useLocalization();
  return (
    <div className="app-layout grid grid-cols-1 gap-4 p-4">
      <div>
        <Card>
          <CardHeader>
            <CardTitle>{t("common.branches")}</CardTitle>
          </CardHeader>
          <CardContent>
            <Branches />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}